/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import PropTypes from "prop-types";
import { Alert } from "bootstrap";
import AlertDialog from "./AlertDialog";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import StepLabel from "@material-ui/core/StepLabel";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Button as ButtonR } from "reactstrap";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
//Steps Screens
import ContentStep from "views/Staff/PublishWizard/ContentStep.js";
import ImagesandLinks from "views/Staff/PublishWizard/ImagesandLinks.js";
import BackOfficeStep from "views/Staff/PublishWizard/BackOfficeStep.js";
import BlogMedia from "views/Staff/PublishWizard/BlogMedia.js";
import MediaInformationComponent from "views/Staff/PublishWizard/MediaInformationComponent.js";
import OwnerDetailsComponent from "views/Staff/PublishWizard/OwnerDetailsComponent.js";
import ParkingDetailsComponent from "views/Staff/PublishWizard/ParkingDetailsComponent.js";
import PowerDetailsComponent from "views/Staff/PublishWizard/PowerDetailsComponent.js";
import BrokerDetailsComponent from "views/Staff/PublishWizard/BrokerDetailsComponent.js";
import StatusComponent from "views/Staff/PublishWizard/StatusComponent.js";
import MetadataComponent from "views/Staff/PublishWizard/MetadataComponent.js";
import ExtrasComponent from "views/Staff/PublishWizard/ExtrasComponent.js";
import TenantDetailsComponent from "views/Staff/PublishWizard/TenantDetailsComponent.js";
import ListingInformationComponent from "views/Staff/PublishWizard/ListingInformationComponent.js";
import CommisionDetailsComponent from "views/Staff/PublishWizard/ComisionDetailsComponent.js";
import MandateDetailsComponent from "views/Staff/PublishWizard/MandateDetailsComponent.js";
import ResidentialPropertyFieldsComponent from "views/Staff/PublishWizard/ResidentialPropertyFields.js";
import PropertyInformationComponent from "views/Staff/PublishWizard/PropertyInformation.js";
import PublicationInformationComponent from "views/Staff/PublishWizard/PublicationInformation.js";
import SecurityInformationComponent from "views/Staff/PublishWizard/SercurityInformation.js";
import PublishingComponent from "views/Staff/PublishWizard/Publishing.js";
import CircularLoading from "./CircularLoading";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: "80vh",
    maxHeight: "20vh"
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: "auto",
    border: "3px solid",
    borderColor: "#399ddb",
    borderRadius: "10px",
    padding: 10,
    flexGrow: 1, // This will make the content area expand
    minHeight: "500px"
  },
  stepper: {
    width: "100%",
    border: "3px solid",
    borderColor: "#399ddb",
    borderRadius: "10px",
    padding: 5
  },
  footer: {
    width: "100%",
    border: "3px solid",
    borderColor: "#399ddb",
    borderRadius: "10px",
    padding: 5,
    marginTop: "auto" // This will push the footer to the bottom
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minHeight: "500px", // Minimum height for the content container
    maxHeight: "20vh"
  },
  div: {
    flexGrow: 1,
    minHeight: "400px", // Minimum height for the scrollable content
    overflowY: "auto",
    maxHeight: "60vh"
  }
}));

function PublishStepper(props) {
  const { api } = useContext(FirebaseContext);
  const {
    publishToWeb,
    publishto24prop,
    publishToprivateprop,
    fetchBroker,
    clearPublishErrors,
    UpdateListing,
    fetchSuburbs,
    fetchCities,
    clearListingErrors
  } = api;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const listingManagementReducer = useSelector((state) => state.ListingData);
  const tokenManagementReducer = useSelector((state) => state.tokendata.token.token);
  const [loading, setLoading] = useState(false)
  const [completed, setCompleted] = React.useState({});
  const [stepContent, setStepContent] = React.useState({});
  const broker = useSelector((state) => state.brokersdata.broker);
  const publishreducer = useSelector((state) => state.publishdata);
  const [Broker, setBroker] = useState([]);
  const [data, setvalue] = useState(props.data);
  const [apiColor, setApiColor] = useState("info");
  const [property24Color, setProperty24Color] = useState("info");
  const [commonAlert, setCommonAlert] = useState({
    open: false,
    msg: "",
    title: ""
  });

  useEffect(() => {
    if (!publishreducer.completed) return;

    const selected = {
      property24: selectedWebsites.property24,
      apiNexus: selectedWebsites.apiNexus,
      privateProperty: selectedWebsites.privateProperty,
    };

    // track results for each portal
    const results = {
      property24: publishreducer.publish
        ? { success: true }
        : publishreducer.error?.portal === "property24"
          ? { success: false, msg: publishreducer.error.msg }
          : null,

      apiNexus: publishreducer.webpublish
        ? { success: true }
        : publishreducer.error?.portal === "apiNexus"
          ? { success: false, msg: publishreducer.error.msg }
          : null,

      privateProperty: publishreducer.privateprop
        ? { success: true }
        : publishreducer.error?.portal === "privateProperty"
          ? { success: false, msg: publishreducer.error.msg }
          : null,
    };

    // build messages dynamically
    const messages = [];
    console.log('publishreducer', publishreducer)
    console.log('results', results)

    if (selected.property24 && results.property24) {
      if (results.property24.success) {
        setvalue((prev) => ({
          ...prev,
          ListingId: publishreducer.publish?.listingNumber,
        }));
        messages.push("✅ Property24: published successfully.\n");
      } else {
        messages.push(`❌ Property24: ${results.property24.msg || "Failed to publish."}\n`);
      }
    }

    if (selected.apiNexus && results.apiNexus) {
      if (results.apiNexus.success) {
        messages.push("✅ API Nexus: published successfully.\n");
      } else {
        messages.push(`❌ API Nexus: ${results.apiNexus.msg || "Failed to publish."}\n`);
      }
    }

    if (selected.privateProperty && results.privateProperty) {
      if (results.privateProperty.success) {
        messages.push("✅ Private Property: published successfully.\n");
      } else {
        messages.push(`❌ Private Property: ${results.privateProperty.msg || "Failed to publish."}\n`);
      }
    }


    console.log('messages', messages)

    // determine if all selected portals finished (success or failure)
    const selectedCount = Object.values(selected).filter(Boolean).length;
    const completedCount = Object.entries(selected)
      .filter(([key, val]) => val && results[key])
      .length;

   setLoading(false);

    // show final summary only when all selected are done
    if (selectedCount > 0 && completedCount === selectedCount) {
      if (messages.length > 0) {
     
        setCommonAlert({
          open: true,
          msg: messages.join("\n"),
        });
      }



      dispatch(clearPublishErrors());
    }
  }, [publishreducer]);


  const [selectedWebsites, setSelectedWebsites] = useState({
    apiNexus: false,
    privateProperty: false,
    property24: false
  });
  useEffect(() => {
    if (props.data) {
      dispatch(fetchBroker(props.data.userdetials.id));
    }
    if (data.provinceId) {
      dispatch(fetchCities(data.provinceId));
      console.log("", data.provinceId);
    }
    if (data.cityId) {
      dispatch(fetchSuburbs(data.cityId));
    }

    setBroker(broker);
  }, [data]);


  useEffect(() => {
    if (
      listingManagementReducer.completed &&
      listingManagementReducer.success &&
      !listingManagementReducer.loading
    ) {
      alert("Infomation Updated");
      dispatch(clearListingErrors());
      //handleNext();
      // dispatch(clearListingErrors());
      // dispatch(fetchUserListinghistory())
      // navigation.goBack();
    }

    if (
      !listingManagementReducer.success &&
      listingManagementReducer.error.flag
    ) {
      console.log(
        "listingManagementReducer.error",
        listingManagementReducer.error.msg
      );
      alert("Error Updating Infomation", listingManagementReducer.error.msg);
      dispatch(clearListingErrors());
    }
  }, [listingManagementReducer]);


  function getSteps() {
    return [
      "Content",
      "Images",
      "BackOffice",
      "Owner \n Details",
      "Broker \n Details",
      "Tenant \n Details",
      "Listing \n Information",
      "Parking /\n Power",
      "Property \n Details",
      "Property \n Information",
      "Security \n Information",
      "Mandate",
      "Status Information",
      "Publishing"
    ];
  }

  const steps = getSteps();
  const stepRefs = React.useRef(steps.map(() => React.createRef()));

  const totalSteps = () => {
    return steps.length;
  };
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    navigate("/stockdetials", {
      state: { item: listingManagementReducer.currentListing },
    });
  };
  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  const handleNext = (newValues) => {

    console.log('newValues', newValues)
    if (newValues) {
      setvalue((prevData) => ({
        ...prevData,
        ...newValues
      }));
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };
  const publishto24 = () => {
    dispatch(publishto24prop(data, broker.agentId));
  };
  const handleComplete = () => {
    const currentRef = stepRefs.current[activeStep];
    if (currentRef && currentRef.current && currentRef.current.isValidated) {
      const isValid = currentRef.current.isValidated();
      if (!isValid) {
        console.log(" Not Valid");
        return; // ❌ Don’t mark as complete if validation fails
      }
    }

    const stepContentData = stepContent[activeStep];

    console.log('stepContent[activeStep]', stepContent[activeStep])

    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);

    if (isLastStep()) {
      console.log("Final submission:", data);
      console.log("token", tokenManagementReducer);
      console.log("Selected Websites:", selectedWebsites);

      let newListingData = {
        ...data,
        syndicateFlags: {
          ...data.syndicateFlags,
          privateProperty: true,
          website: true,
          property24: true,
        }
      }



      dispatch(UpdateListing(newListingData));

      // Trigger API calls based on selected websites
      if (selectedWebsites.apiNexus) {
        dispatch(publishToWeb(data));
        setLoading(true);
      }
      if (selectedWebsites.property24) {
        dispatch(publishto24prop(data, broker.agentId));
        setLoading(true);
      }
      if (selectedWebsites.privateProperty) {
        // Add your private property API call here
        dispatch(publishToprivateprop());
        setLoading(true);
      }
    } else {
      handleNext(stepContentData);
    }
  };
  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  // function getSteps() {
  //   return [
  //     "Content",
  //     "Images",
  //     "BackOffice",
  //     "Owner \n Details",
  //     "Broker \n Details",
  //     "Tenant \n Details",
  //     "Listing \n Information",
  //     "Parking",
  //     "Residential \n Information",
  //     "Property \n Information",
  //     "Security \n Information",
  //     "Mandate",
  //     "Status Imformation",
  //     "Publishing"
  //   ];
  // }
  const handleOpenLink = (website) => {
    let url = "";
    switch (website) {
      case "apiNexus":
        url = `https://api-prop.plum.systems/index.php/properties#sort=attr.cat.frontend_value&sortdir=asc`;
        break;
      case "privateProperty":
        url = `https://www.privateproperty.co.za/`; // Add correct URL
        break;
      case "property24":
        url = `https://www.property24.com/for-sale/search?SearchText=${data?.ListingId}`; // Add correct URL
        break;
      default:
        url = `https://api-prop.plum.systems/index.php/properties#sort=attr.cat.frontend_value&sortdir=asc`;
    }
    window.open(url, "_blank");
  };
  function finalSteps() {
    return (
      <>
        <Paper elevation={5} sx={{ p: 3 }}>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={4}>
                <FormControlLabel
                  value="bottom"
                  control={
                    <Switch
                      color="success"
                      checked={selectedWebsites.apiNexus}
                      onChange={(e) =>
                        setSelectedWebsites((prev) => ({
                          ...prev,
                          apiNexus: e.target.checked
                        }))
                      }
                    />
                  }
                  label="API-Nexus Website"
                  labelPlacement="end"
                  sx={{
                    fontSize: "1.2rem",
                    color: "#333",
                    mb: 2,
                    "& .MuiFormControlLabel-label": {
                      fontSize: "1.2rem",
                      fontWeight: 500
                    }
                  }}
                />
              </GridItem>
              {/* <GridItem xs={8}>
                {publishreducer?.webpublish ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenLink("apiNexus")}
                    sx={{ mt: 2 }}
                  >
                    View Property
                  </Button>
                ) : null}
              </GridItem> */}
              {(data.BranchPPId && data.userdetials.PPagentId) ? (<GridItem xs={4}>
                <FormControlLabel
                  value="bottom"
                  control={
                    <Switch
                      color="success"
                      checked={selectedWebsites.privateProperty}
                      onChange={(e) =>
                        setSelectedWebsites((prev) => ({
                          ...prev,
                          privateProperty: e.target.checked
                        }))
                      }
                    />
                  }
                  label="Private Property"
                  labelPlacement="end"
                  sx={{
                    fontSize: "1.2rem",
                    color: "#333",
                    mb: 2,
                    "& .MuiFormControlLabel-label": {
                      fontSize: "1.2rem",
                      fontWeight: 500
                    }
                  }}
                />
              </GridItem>) : <p>Can not publish to Private Property because you are missing a branch id or an agent id. Please contact support</p>}
              {/* <GridItem xs={8}>
                {publishreducer?.proppublish ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenLink("privateProperty")}
                    sx={{ mt: 2 }}
                  >
                    View Property
                  </Button>
                ) : null}
              </GridItem> */}

              <GridItem xs={4}>
                <FormControlLabel
                  value="bottom"
                  control={
                    <Switch
                      color="success"
                      checked={selectedWebsites.property24}
                      onChange={(e) =>
                        setSelectedWebsites((prev) => ({
                          ...prev,
                          property24: e.target.checked
                        }))
                      }
                    />
                  }
                  label="Property 24"
                  labelPlacement="end"
                  sx={{
                    fontSize: "1.2rem",
                    color: "#333",
                    mb: 2,
                    "& .MuiFormControlLabel-label": {
                      fontSize: "1.2rem",
                      fontWeight: 500
                    }
                  }}
                />
              </GridItem>
              {/* <GridItem xs={8}>
                {publishreducer?.publish ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenLink("property24")}
                    sx={{ mt: 2 }}
                  >
                    View Property
                  </Button>
                ) : null}
              </GridItem> */}
            </GridContainer>
          </GridItem>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2rem"
            }}
          >
            <FormControl component="fieldset" sx={{ mt: 2 }}>
              <FormGroup aria-label="position"></FormGroup>
            </FormControl>
          </div>
        </Paper>
      </>
    );
  }

  // const steps = getSteps();
  function getStepContent(stepIndex) {
    const isLastStep = activeStep === steps.length - 1;
    switch (stepIndex) {
      case 0:
        return (
          <ContentStep
            data={data}
            ref={stepRefs.current[0]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 1:
        return (
          <ImagesandLinks
            data={data}
            ref={stepRefs.current[1]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 2:
        return (
          <BackOfficeStep
            ref={stepRefs.current[2]}
            data={data}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 3:
        return (
          <OwnerDetailsComponent
            data={data}
            ref={stepRefs.current[3]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 4:
        return (
          <BrokerDetailsComponent
            data={data}
            ref={stepRefs.current[4]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 5:
        return (
          <TenantDetailsComponent
            data={data}
            ref={stepRefs.current[5]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 6:
        return (
          <ListingInformationComponent
            data={data}
            ref={stepRefs.current[6]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 7:
        return (
          <ParkingDetailsComponent
            data={data}
            ref={stepRefs.current[7]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 8:
        return (
          <ResidentialPropertyFieldsComponent
            data={data}
            ref={stepRefs.current[8]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 9:
        return (
          <PropertyInformationComponent
            data={data}
            ref={stepRefs.current[9]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 10:
        return (
          <SecurityInformationComponent
            data={data}
            ref={stepRefs.current[10]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 11:
        return (
          <MandateDetailsComponent
            data={data}
            ref={stepRefs.current[11]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 12:
        return (
          <StatusComponent
            data={data}
            ref={stepRefs.current[12]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      case 13:
        return (
          <PublishingComponent
            data={data}
            ref={stepRefs.current[13]}
            setvalue={(updatedData) => {
              setvalue(updatedData); // Update parent state too
            }}
            activeStep={activeStep}
            isLastStep={isLastStep}
          />
        );
      default:
        return finalSteps();
    }
  }



  return (publishreducer.loading || loading) ? (
    <CircularLoading label={"Just a Minute Getting Everything Done For You"} />
  ) : (
    <div className={classes.root}>
      <div className={classes.stepper}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label, index) => (
            <Step key={label.id}>
              {/* <StepLabel>{label}</StepLabel> */}

              <StepButton
                onClick={handleStep(index)}
                completed={completed[index]}
              >
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </div>
      <div>
        {allStepsCompleted() ? (
          <div>
            <Typography className={classes.instructions}>
              <div className={classes.div}>
                {finalSteps()}
                <div style={{ marginTop: "20px", textAlign: "center" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      //Trigger all selected publications
                      if (selectedWebsites.apiNexus) {
                        dispatch(publishToWeb(data));
                      }
                      if (selectedWebsites.property24) {
                        dispatch(publishto24prop(data, broker.agentId));
                      }
                      if (selectedWebsites.privateProperty) {
                        // Add your private property API call here
                        let privatePData = {
                          ...data,
                          createPublish: true
                        }
                        dispatch(publishToprivateprop(privatePData, tokenManagementReducer));
                      }
                    }}
                  >
                    Publish to Selected Platforms
                  </Button>
                </div>
              </div>
            </Typography>
          </div>
        ) : (
          <div>
            <div>
              <Typography className={classes.instructions}>
                <div className={classes.div}>{getStepContent(activeStep)}</div>
              </Typography>
            </div>
            <div className={classes.footer}>
              <Paper elevation={5} sx={{ p: 3 }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.button}
                >
                  Back
                </Button>


                {completed[activeStep] && (<Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleNext()}
                  className={classes.button}
                >
                  Next
                </Button>)}


                {activeStep !== steps.length &&
                  (completed[activeStep] ? (
                    <Typography variant="caption" className={classes.completed}>
                      Step {activeStep + 1} already completed
                    </Typography>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleComplete}
                    >
                      {completedSteps() === totalSteps() - 1
                        ? "Finish"
                        : "Complete Step"}
                    </Button>
                  ))}
              </Paper>
            </div>
          </div>
        )}
      </div>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
        {/* {commonAlert.title} */}
      </AlertDialog>
    </div>
  )
};

PublishStepper.propTypes = {
  container: PropTypes.instanceOf(
    typeof Element === "undefined" ? Object : Element
  )
};

export default PublishStepper;
